(function () {
  'use strict';

  var modal = document.getElementById('LsEnquiryModal');
  if (!modal) return;

  var productInput = modal.querySelector('[data-enquiry-product-input]');
  var urlInput = modal.querySelector('[data-enquiry-url-input]');
  var bodyInput = modal.querySelector('[data-enquiry-body-input]');
  var productLabel = modal.querySelector('[data-enquiry-product-label]');
  var firstInput = modal.querySelector('input:not([type="hidden"])');
  var lastTrigger = null;

  function openModal(trigger) {
    var product = trigger.getAttribute('data-product-title') || document.title;
    var productUrl = trigger.getAttribute('data-product-url') || window.location.href;
    if (productUrl.charAt(0) === '/') productUrl = window.location.origin + productUrl;

    productInput.value = product;
    urlInput.value = productUrl;
    bodyInput.value = 'Product enquiry for: ' + product + '\nProduct URL: ' + productUrl;
    productLabel.textContent = product;
    lastTrigger = trigger;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ls-enquiry-open');
    window.setTimeout(function () { if (firstInput) firstInput.focus(); }, 100);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ls-enquiry-open');
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-enquiry-open]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
      return;
    }
    if (event.target.closest('[data-enquiry-close]')) closeModal();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  function updateProductButtons(variant) {
    if (!variant || typeof variant.price === 'undefined') return;
    var isEnquiry = Number(variant.price) === 0;
    document.querySelectorAll('[data-enquiry-product-form]').forEach(function (form) {
      form.querySelectorAll('[data-enquiry-product-button]').forEach(function (button) { button.hidden = !isEnquiry; });
      form.querySelectorAll('[data-enquiry-buy-button], [data-enquiry-qty], [data-enquiry-payment]').forEach(function (element) { element.hidden = isEnquiry; });
    });
  }

  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:changed.lsEnquiry', function (event) {
      updateProductButtons(event.currentVariant);
    });
  }

  if (modal.querySelector('[data-enquiry-success], [data-enquiry-error]')) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ls-enquiry-open');
  }
})();
